import { BusinessProcessEvent } from './BusinessProcessEvent';
import { ComponentType } from './ComponentType';
import { ItEventType } from './ItEventType';
import { PropertyName } from '../utils/Constants';

export class SystemEvent extends BusinessProcessEvent {

    private systemMessage: string;

    constructor(businessProcessName: string, componentType: ComponentType)
    constructor(businessProcessName: string, componentType: ComponentType, systemMessage: string)
    constructor(businessProcessName: string, componentType: ComponentType, systemMessage?: string) {
        super(businessProcessName, componentType, null, null);
        this.systemMessage = systemMessage;
        this.EventType = ItEventType.SystemEvent;
    }

    public get SystemMessage(): string {
        return this.systemMessage;
    }

    public set SystemMessage(value: string) {
        this.systemMessage = value;
    }

    public IsValidEvent(): boolean {
        if (!this.EventName || 0 === this.EventName.length) {
            return false;
        }
        else {
            return true;
        }
    }

    public getTelemetryObject(){
        let properties = {};
        properties[PropertyName.BusinessProcessName] = this.BusinessProcessName;
        properties[PropertyName.TargetEntityKey] = this.TargetEntityKey;
        properties[PropertyName.AppAction] = this.AppAction;
        properties[PropertyName.ActionUri] = this.ActionUri;
        properties[PropertyName.ComponentType] = this.ComponentType;
        properties[PropertyName.Xcv] = this.Xcv;
        properties[PropertyName.UserRoleName] = this. UserRoleName;
        properties[PropertyName.SenderId] = this.SenderId;
        properties[PropertyName.ReceiverId] = this.ReceiverId;
        properties[PropertyName.MessageId] = this.MessageId;
        properties[PropertyName.EventOccurrenceTime] = this.EventOccurrenceTime;
        properties[PropertyName.EventType] = this.EventType;
        properties[PropertyName.MsitPartB] = true;
        properties[PropertyName.StartDateTime] = this.StartDateTime;
        properties[PropertyName.EndDateTime] = this.EndDateTime;
        properties[PropertyName.TemplateType] = this.TemplateType;
        return properties;
    }
}
